import { useContext, useEffect, useState } from "react";
import CustomOrgChart from "../common/hierarchy/CustomOrgChart";
import { fetchEmployees, getTeamHierarchy } from "../../api/companyStructureApi/companyStructureApi";
import { convertHierarchy } from "../common";
import { Col, Container, Row } from "react-bootstrap";
import Context from "../../context/Context";


const TeamHierarchy = () => {
    const [hierarchyData, setHierarchyData] = useState({});
    const id = localStorage.getItem('company_id');
    const [members, setMembers] = useState([]);
    const { user, setPageTitle } = useContext(Context);
    const [isLoading, setIsLoading] = useState(false);


    const getEmployeesListing = () => {
        fetchEmployees({ page: false }, (response) => {
            if (response?.status === true) {
                setMembers(response?.data);
            }
        });
    };

    useEffect(() => {
        setIsLoading(true);
        setPageTitle('Team Structure');
        getTeamHierarchy(id, (res) => {
            if (res?.status === true) {
                const { company_head, teams } = res?.data;
                setHierarchyData(convertHierarchy({ company_head, teams }));
            }
            setIsLoading(false);
        });

        getEmployeesListing();
    }, [id, setPageTitle]);

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
            </div>
        );
    }

    return (
        <div className=" px-2">
            <Container fluid >
                <Row >
                    <Col xs={12} md={12}  >
                        <CustomOrgChart
                            singleCompanyHierarchy={hierarchyData}
                            isAddEdit={user?.role === 'Company Head'}
                            minHeight='120px'
                            id={id}
                            members={members}
                        />
                    </Col>
                </Row>
            </Container>
        </div>

    );
};

export default TeamHierarchy;